import React, { useEffect } from 'react';
import { analytics } from '../../analytics';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';


const BetterDocsWidget = () => {
  useEffect(() => {
    // console.log('BetterDocs Widget mounting...');
    // Create and load the stylesheet
    const linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = 'https://www.marketplaceiq.io/wp-content/plugins/betterdocs-pro/assets/public/css/instant-answer.css';
    document.head.appendChild(linkElement);

    // Create and load the script
    const script = document.createElement('script');
    script.src = 'https://www.marketplaceiq.io/wp-content/plugins/betterdocs-pro/assets/public/js/instant-answer-cd.js';
    script.async = true;

    // Add the BetterDocs configuration
    window.betterdocs = {
      "IA_NONCE": "73edf85f48",
      "BASE_URL": "https://www.marketplaceiq.io/wp-json/",
      "CHAT": {
        "show": true,
        "label": "Ask",
        "subtitle": "Need a hand? Shoot us a message.",
        "subtitle_two": "We typically respond within 24-48 hours. Your solution is just a message away."
      },
      "ANSWER": {
        "label": "Answer",
        "subtitle": "Instant Answer"
      },
      "URL": "https://www.marketplaceiq.io/wp-json/wp/v2/docs",
      "SEARCH": {
        "show": false,
        "SEARCH_URL": "https://www.marketplaceiq.io/wp-json/wp/v2/docs",
        "SEARCH_PLACEHOLDER": "Search...",
        "OOPS": "Oops...",
        "NOT_FOUND": "We couldn't find any docs that match your search. Try searching for a new term."
      },
      "FEEDBACK": {
        "DISPLAY": false,
        "SUCCESS": "Thanks for the feedback",
        "TEXT": "How did you feel?",
        "URL": "https://www.marketplaceiq.io/wp-json/betterdocs/v1/feedback"
      },
      "RESPONSE": [],
      "ASKFORM": {
        "NAME": "Name",
        "EMAIL": "Email Address",
        "SUBJECT": "Subject",
        "TEXTAREA": "How can we help?",
        "ATTACHMENT": "Accepts .gif, .jpeg, png, pdf, jpg and .png",
        "SENDING": "Sending",
        "SEND": "Send",
        "FILE_UPLOAD_SWITCH": true
      },
      "ASK_URL": "https://www.marketplaceiq.io/wp-json/betterdocs/v1/ask",
      "HOME_FAQ": {
        "FAQ_URL": "https://www.marketplaceiq.io/wp-json/wp/v2/betterdocs_faq?per_page=100",
        "HOME_FAQ_CONTENT_TYPE": "faq-list"
      },
      "FAQ": {
        "faq-title": "FAQ",
        "faq-switch": true,
        "faq_content_type": "faq-list",
        "faq-terms": [],
        "faq-list": [],
        "faq-terms-order": "asc",
        "faq-terms-order-by": "name",
        "faq-list-orderby": "id",
        "faq-list-order": "asc"
      },
      "DOC_CATEGORY": {
        "doc-title": "Doc Categories",
        "doc-terms": [],
        "doc-category-switch": true,
        "doc-terms-order": "asc",
        "doc-terms-order-by": "name",
        "doc-subcategory-switch": true
      },
      "HOME_TAB_TITLE": "Home",
      "HOME_CONTENT": "docs",
      "HOME_CONTENT_DOC_CATEGORY_TITLE": "Doc Categories",
      "HOME_CONTENT_DOCS_TITLE": "Docs",
      "HOME_TITLE": "Get Instant Help",
      "HOME_SUBTITLE": "Need any assistance? Get quick solutions to any problems you face.",
      "RESOURCES_TITLE": "Resources",
      "RESOURCES_TAB_TITLE": "Resources",
      "HEADER_ICON": {
        "id": 6677,
        "title": "Rectangle 240648843",
        "url": "https://www.marketplaceiq.io/wp-content/uploads/2024/12/Rectangle-240648843.png"
      },
      "HEADER_LOGO": [],
      "TAB_HOME_ICON": [],
      "TAB_MESSAGE_ICON": [],
      "TAB_RESOURCE_ICON": [],
      "BRANDING": {
        "show": false
      },
      "THANKS": {
        "title": "Thanks",
        "text": "Your Message Has Been Sent Successfully"
      }
    };

    script.onload = () => {
      // console.log('BetterDocs script loaded successfully');
    };
    script.onerror = (error) => {
      console.error('Error loading BetterDocs script:', error);
    };
    document.body.appendChild(script);


    // Cleanup function
    return () => {
      if (linkElement.parentNode) {
        linkElement.parentNode.removeChild(linkElement);
      }
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  const {currentUser} = useSelector((state: RootState) => state.user);

  return (
    <div className="betterdocs-cross-domain-code hidden md:block"

    >
      <div id="betterdocs-ia" className="w-full h-full"
          onClick={()=>{
            analytics.sendSupportChatOpenedEvent({
              email: currentUser?.email ?? "unknown",
            });
          }} 
      ></div>
      <style>{`
            /* Primary colors and styles with Tailwind's blue-600 to indigo-700 gradient */
        .betterdocs-ia-common-header {
          background: linear-gradient(to right, rgb(37, 99, 235), rgb(67, 56, 202)) !important;
        }
        
        .betterdocs-ia-launcher-wrapper .betterdocs-ia-launcher {
          background: linear-gradient(to right, rgb(37, 99, 235), rgb(67, 56, 202)) !important;
          transition: all 0.3s ease !important;
                    z-index: 40 !important; /* Add this */

        }

        .betterdocs-ia-common-header .betterdocs-ia-search .betterdocs-ia-search-icon,
        .betterdocs-ia-tab-message-container .betterdocs-ia-feedback-form .betterdocs-ia-submit button,
        .betterdocs-ia-single-docs-wrapper .betterdocs-ia-singleDoc-footer .betterdocs-ia-footer-feedback {
          background: linear-gradient(to right, rgb(37, 99, 235), rgb(67, 56, 202)) !important;
                    z-index: 40 !important; /* Add this */

        }

        /* Position adjustments */
        .betterdocs-ia-launcher-wrapper {
          right: 32px !important;
          bottom: 32px !important;
        }

        /* Rest of the styles */
        .betterdocs-ia-single-docs-wrapper .betterdocs-ia-singleDoc-header,
        .betterdocs-ia-tabs .active p {
          color: rgb(37, 99, 235) !important; /* blue-600 */
        }

        .betterdocs-ia-single-docs-wrapper .betterdocs-ia-singleDoc-header .content-icon-expand svg path,
        .betterdocs-ia-docs-content .content-icon svg path,
        .betterdocs-ia-single-docs-wrapper .betterdocs-ia-singleDoc-header .content-icon-back svg path,
        .betterdocs-ia-tabs li.active svg g path {
          fill: rgb(37, 99, 235) !important; /* blue-600 */
        }

        .betterdocs-ia-launcher-wrapper .betterdocs-ia-launcher:hover {
          background: linear-gradient(to right, rgb(37, 99, 235), rgb(67, 56, 202)) !important;
          opacity: 0.9;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25) !important;
        }

        .betterdocs-ia-single-docs-wrapper .betterdocs-ia-singleDoc-footer .betterdocs-ia-footer-feedback .betterdocs-ia-reaction-group .ia-reaction {
          background: linear-gradient(to right, rgb(37, 99, 235), rgb(67, 56, 202)) !important;
        }

        /* Remove default circle background pattern */
        .betterdocs-ia-common-header::before,
        .betterdocs-ia-common-header::after {
          display: none !important;
        }
      `}</style>
    </div>
  );
};

export default BetterDocsWidget;